import React from "react";

function Header() {
    return (
        <header className="px-5 pt-3 pb-0">
            <h1 className="text-3xl text-[#173B45] font-extrabold">sqdle</h1>
        </header>
    );
}

export default Header;
